import { useCurrentRateGroupContext } from '../../../../contexts';

export const useSafeCurrentRateGroupContext = () => {
    try {
        return useCurrentRateGroupContext();
    } catch {
        return undefined;
    }
};
